import { LI, UL } from "../../../AbstractElements";
import { Href } from "../../../Constant";

const UserProfileIcon = () => {
  return (
    <UL className="share-icons simple-list d-flex flex-row">
      <LI><a className="social-icon bg-primary" href={Href}><i className="fa fa-smile-o me-0" /></a></LI>
      <LI><a className="social-icon bg-secondary" href={Href}><i className="fa fa-wechat me-0" /></a></LI>
      <LI><a className="social-icon bg-warning" href={Href}><i className="fa fa-share-alt me-0" /></a></LI>
    </UL>
  );
};

export default UserProfileIcon;
